<template>
  <div class="header-wraper">
    <navigation
      @click.native="
        showMarketHeader && ($refs.marketChild.searchOpened = false)
      "
    ></navigation>
    <market ref="marketChild" v-if="showMarketHeader"></market>
  </div>
</template>

<script>
import market from './Market'
import navigation from './Navigation'

export default {
  name: 'WholeHeader',
  components: {
    navigation,
    market,
  },
  computed: {
    showMarketHeader() {
      return (
        this.$route.name === 'Home' || this.$route.name === 'FullSizedWidgets'
      )
    },
  },
}
</script>

<style lang="scss">
.header-wraper {
  position: relative;
  @media (max-width: 768px) {
    width: 100%;
    z-index: 9999;
  }
}
</style>
